/* eslint-disable react/prop-types */
import React from 'react'
import { connect } from 'react-redux'

import { deleteSelected, newRule, toggleActive, toggleSound } from '../../actions'
import { Actions, Action, ActionOption, ActionWithOptions } from '../styles/list'

const ListButtons = ({
    showExportFilenameModal,
    sideview,
    onUpload,

    buttonSaveStatus,
    canEditGlobal,
    channel,
    hasGlobalRules,
    noneSelected,

    deleteSelected,
    newRule,
    toggleActive,
    toggleSound
}) => {
    const disabled = noneSelected || buttonSaveStatus.saving
    const noPermission = !canEditGlobal && hasGlobalRules

    return (
        <Actions>
            <Action
                onClick={() =>
                    newRule({
                        conditions: [sideview ? { channel } : {}]
                    })
                }
                className="btn btn-primary"
                disabled={buttonSaveStatus.saving}
            >
                <i className="far fa-plus" />
                New alarm
            </Action>
            <ActionWithOptions
                title={
                    <div className="btn-options">
                        <i
                            className={`far ${
                                buttonSaveStatus.saving && buttonSaveStatus.button === 'import'
                                    ? 'fa-spinner fa-spin'
                                    : 'fa-file-import'
                            }`}
                        />
                        {buttonSaveStatus.saving && buttonSaveStatus.button === 'import' ? 'Importing' : 'Import'}
                    </div>
                }
                disabled={buttonSaveStatus.saving}
                id="alarm-dropdown-import"
            >
                <ActionOption onSelect={onUpload}>
                    <i className="far fa-file-code" />
                    From file...
                </ActionOption>
            </ActionWithOptions>
            <Action disabled={disabled} className="btn btn-default" onClick={showExportFilenameModal}>
                <i className="far fa-file-export" />
                Export JSON
            </Action>
            {sideview ? null : (
                <>
                    <Action
                        onClick={() => toggleActive(true)}
                        disabled={noPermission || disabled}
                        className="btn btn-default"
                    >
                        <i
                            className={`far ${
                                buttonSaveStatus.saving && buttonSaveStatus.button === 'activate'
                                    ? 'fa-spinner fa-spin'
                                    : 'fa-bell'
                            }`}
                        />
                        {buttonSaveStatus.saving && buttonSaveStatus.button === 'activate'
                            ? 'Activating...'
                            : 'Activate'}
                    </Action>
                    <Action
                        onClick={() => toggleActive(false)}
                        disabled={noPermission || disabled}
                        className="btn btn-default"
                    >
                        <i
                            className={`far ${
                                buttonSaveStatus.saving && buttonSaveStatus.button === 'deactivate'
                                    ? 'fa-spinner fa-spin'
                                    : 'fa-bell-slash'
                            }`}
                        />
                        {buttonSaveStatus.saving && buttonSaveStatus.button === 'deactivate'
                            ? 'Deactivating...'
                            : 'Deactivate'}
                    </Action>
                    <ActionWithOptions
                        disabled={noPermission || disabled}
                        title={
                            <div className="btn-options">
                                <i
                                    className={`far ${
                                        buttonSaveStatus.saving && buttonSaveStatus.button === 'sound'
                                            ? 'fa-spinner fa-spin'
                                            : 'fa-volume'
                                    }`}
                                />
                                {buttonSaveStatus.saving && buttonSaveStatus.button === 'sound' ? 'Saving...' : 'Sound'}
                            </div>
                        }
                        id="alarm-dropdown-sound"
                    >
                        <ActionOption onSelect={() => toggleSound(true)}>
                            <i className="far fa-volume" />
                            Activate
                        </ActionOption>
                        <ActionOption onSelect={() => toggleSound(false)}>
                            <i className="far fa-volume-mute" />
                            Deactivate
                        </ActionOption>
                    </ActionWithOptions>
                    <Action onClick={deleteSelected} disabled={noPermission || disabled} className="btn btn-default">
                        <i
                            className={`far ${
                                buttonSaveStatus.saving && buttonSaveStatus.button === 'delete'
                                    ? 'fa-spinner fa-spin'
                                    : 'fa-trash-alt'
                            }`}
                        />
                        {buttonSaveStatus.saving && buttonSaveStatus.button === 'delete' ? 'Deleting...' : 'Delete'}
                    </Action>
                </>
            )}
        </Actions>
    )
}

function mapStateToProps({ editorReducer: { buttonSaveStatus, canEditGlobal, channel, localRules, selected } }) {
    return {
        buttonSaveStatus,
        canEditGlobal,
        channel,
        hasGlobalRules: localRules.some(r => r.global),
        noneSelected: selected.size === 0
    }
}

export default connect(mapStateToProps, { deleteSelected, newRule, toggleActive, toggleSound })(ListButtons)
